import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    ", ";\n    ", ";\n\n    &:first-child {\n        padding-left: 0;\n    }\n\n    &:last-child {\n        padding-right: 0;\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        padding: 0 ", "px 0;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        width: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import styled, { css } from 'styled-components';
import React, { useContext } from 'react';
import { GroupContext } from './GroupContext';

function width(_ref) {
  var itemWidth = _ref.itemWidth;

  if (!itemWidth) {
    return null;
  }

  var value = typeof itemWidth === 'number' ? "".concat(itemWidth, "px") : itemWidth;
  return css(_templateObject(), value);
}

function gap(_ref2) {
  var gap = _ref2.gap;

  if (gap == null) {
    return null;
  }

  return css(_templateObject2(), gap / 2);
}

var StyledItem = styled.div(_templateObject3(), width, gap);
export function Item(_a) {
  var children = _a.children,
      gap = _a.gap,
      width = _a.width,
      props = __rest(_a, ["children", "gap", "width"]);

  var contextState = useContext(GroupContext);
  return React.createElement(StyledItem, Object.assign({
    itemWidth: width || contextState.itemWidth,
    gap: gap || contextState.gap
  }, props), children);
}
Item.displayName = 'Item';